module.exports = __webpack_public_path__ + "static/media/left_background.58187ea7.png";